import { render, staticRenderFns } from "./CaseManagementList.vue?vue&type=template&id=487d6a22"
import script from "./CaseManagementList.vue?vue&type=script&lang=js"
export * from "./CaseManagementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports